import type { AppMeta } from "@calcom/types/App";

import _package from "./package.json";

export const metadata = {
  name: "Giphy",
  description: _package.description,
  installed: true,
  categories: ["other"],
  logo: "icon.svg",
  publisher: "Schedly",
  slug: "giphy",
  title: "Giphy",
  type: "giphy_other",
  url: "https://schedly.io/apps/giphy",
  variant: "other",
  extendsFeature: "EventType",
  email: "support@schedly.io",
  dirName: "giphy",
  isOAuth: false,
} as AppMeta;

export default metadata;
